import { EMS_ERROR_AFTER_MS, EMS_WARNING_AFTER_MS } from '@/features/telemetry/config';

export type EmsLevel = 'ok' | 'warning' | 'error' | 'offline';

/**
 * Derives the EMS status bar's level from connectivity state and message age.
 *
 * `isOnline: false` or a never-seen EMS (`lastMessageAt === null`) always reads as
 * `offline`, regardless of how the age thresholds would otherwise classify it.
 */
export function resolveEmsLevel(
  lastMessageAt: Date | null,
  isOnline: boolean,
  now: Date
): EmsLevel {
  if (!isOnline || lastMessageAt === null) {
    return 'offline';
  }

  const ageMs = now.getTime() - lastMessageAt.getTime();

  if (ageMs > EMS_ERROR_AFTER_MS) {
    return 'error';
  }
  if (ageMs > EMS_WARNING_AFTER_MS) {
    return 'warning';
  }
  return 'ok';
}
